/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Destructive_Writes_Share_ResetsInputs */



/**
* | output |
* | --- |
* | "Sharing this agent more widely turns this setting off. Once the change is saved, an administrator can turn it back on by editing the agent again." |
*
* @param {Agent_Builder_Destructive_Writes_Share_ResetsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_destructive_writes_share_resets = /** @type {((inputs?: Agent_Builder_Destructive_Writes_Share_ResetsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Destructive_Writes_Share_ResetsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird dieser Agent breiter geteilt, wird diese Einstellung deaktiviert. Nach dem Speichern kann eine Administratorin oder ein Administrator sie wieder aktivieren, indem der Agent erneut bearbeitet wird.")
	return /** @type {LocalizedString} */ ("Sharing this agent more widely turns this setting off. Once the change is saved, an administrator can turn it back on by editing the agent again.")
});